//* Home *//
import { routes } from 'app/routes';

export const QUICK_GUIDE = [
  {
    icon: '/assets/images/identity-white.svg',
    title: 'title_1',
    subTitle: 'subtitle_1',
    subTitle2: [{ title: 'subtitle_1_1' }, { title: 'subtitle_1_2' }],
    color: 'rgb(0, 95, 238)',
    route: routes.IDENTITY,
  },
  {
    icon: '/assets/images/identity-white.svg',
    title: 'title_2',
    subTitle: 'subtitle_2',
    subTitle2: [{ title: 'subtitle_2_1' }, { title: 'subtitle_2_2' }, { title: 'subtitle_2_3' }],
    color: 'rgb(238, 114, 0)',
    route: routes.PRIVACY,
  },
  {
    icon: '/assets/images/messages-white.svg',
    title: 'title_3',
    subTitle: 'subtitle_3',
    subTitle2: [{ title: 'subtitle_3_1' }, { title: 'subtitle_3_2' }, { title: 'subtitle_3_3' }],
    color: 'green',
    route: routes.MESSAGES,
  },
  {
    icon: '/assets/images/settings-white.svg',
    title: 'title_4',
    subTitle: 'subtitle_4',
    color: 'rgb(63, 81, 181)',
    route: routes.SETTINGS,
  },
];

export const WIDGETS_INITIAL_STATE = {
  dataSources: { value: 'Data Sources', visibility: true },
  dataScanning: { value: 'Data Scanning', visibility: true },
  quickGuide: { value: 'Quick Guide', visibility: true },
  newsFeeds: { value: 'News Feed', visibility: true },
  enisaNews: { value: 'Enisa News', visibility: true },
  certFeeds: { value: 'Cert Feed', visibility: true },
  officeInfo: { value: 'Office Info', visibility: true },
};

/* Privacy */

export const DEFAULT_POLICY = 'uuid-for-icah-policy-type';

export const DEFAULT_POLICY_VALUE = {
  id: '',
  policyType: '',
  templateId: '',
  name: '',
  comment: '',
  created: '',
  lastSaved: '',
  activationDates: [],
  isActive: false,
  beingEdited: false,
};

/* Insights */
export const LINE_CHART_COLORS_V2 = [
  '#E24BE6',
  '#6D658A',
  '#DD9DDA',
  '#9DF162',
  '#65838A',
  // '#834080',
  '#44D086',
];
